import { IProfessionalSkill, ProfessionalSkill } from './professional-skill';
import { IOccupationExperience, OccupationExperience } from './occupation-experience';
import { IDataMap } from '../../interfaces/data-map.interface';
import { IVesselSection } from '../../services/job-rank/job-rank.service';

export interface IOveralTime {
  month?: number;
  years?: number;
}

export interface ISkills {
  important_personal_abilities?: string[];
  important_professional_skills?: IProfessionalSkill[];
  occupational_experience?: IOccupationExperience[];
}

export class Skills {
  important_personal_abilities: string[];
  important_professional_skills: ProfessionalSkill[];
  occupational_experience: OccupationExperience[];

  constructor( skills: ISkills = {},
               vesselSectionsMap: IDataMap<IVesselSection> = {} ) {
    this.important_personal_abilities = skills.important_personal_abilities || [];
    this.important_professional_skills = (skills.important_professional_skills || []).map(( skill ) => new ProfessionalSkill(skill));
    this.occupational_experience = (skills.occupational_experience || []).map(( skill ) => {
      const experience = new OccupationExperience(skill);
      experience.sectionName = vesselSectionsMap[ experience.section ] ? vesselSectionsMap[ experience.section ].name : '';
      return experience;
    });
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/skills.ts